import { AccessorsMutatorsDecorator, Model } from "../../helpers";

/**
 * @class RatingFactors
 *
 * @property {number} id
 */
export class RatingFactors extends Model {
  get rating_factor() {
    return this._rating_factor;
  }
}

AccessorsMutatorsDecorator("id", "rating_factor", "rate")(RatingFactors);



// WEBPACK FOOTER //
// ./src/pms-api/models/rating-factors.model.js